import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError, map} from 'rxjs/operators'
import { Utils } from "src/app/core/utils";
import { LogEntry } from "../logEntry";
import { LogPublisher } from "./log-publisher";

export class LogWebApi extends LogPublisher {

    apiEndPoint = Utils.getApiEndPoint();

    constructor(private http: HttpClient) {
        // Must call `super()`from derived classes
        super();
        
        // Set location
        this.location = "/api/log";
    }
    
    // Add log entry to back end data store
    log(entry: LogEntry): Observable<boolean> {
        let option = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
       
        return this.http.post<any>(this.apiEndPoint + `Log`, entry, option)
        .pipe(
            map(response => {
               
                return response;
            }),
            catchError(this.handleErrors)
        )
    }
    
    // Clear all log entries from local storage
    clear(): Observable<boolean> {
        // TODO: Call Web API to clear all values
        return of(true);
    }
    
    private handleErrors(error: any): Observable<any> {
        let errors: string[] = [];
        let msg: string = "";
        
        msg = "Status: " + error.status;
        msg += " - Status Text: " + error.statusText;
        if (error) {
            msg += " - Exception Message: " + error.exceptionMessage;
        }
        errors.push(msg);
        
        console.error('An error occurred', errors);
        return throwError(() => errors);
    }
}
